module.exports = __webpack_public_path__ + "assets/img/smartTV-module4-12.809f29e4.jpg";